import * as React from "react"
import { randomId } from "../identifiers"

export function useBrowserSession() {
    const browserSessionId = React.useMemo(() => {
        if (typeof window === "undefined") return "00000000-0000-4000-8000-000000000000"
        const key = "arctic-hire:browser-session"
        try {
            const existing = window.localStorage.getItem(key)
            if (existing) return existing
            const created = randomId()
            window.localStorage.setItem(key, created)
            return created
        } catch { return randomId() }
    }, [])

    return {
        browserSessionId,
    }
}
